import { Fragment, FunctionComponent } from "react";
import { Avatar } from "../avatar/Avatar.component";
import { userUiI18n } from "../i18n/UserUiI18n.const";
import { IProfileProps } from "./interfaces/IProfileProps";
import "./styles/profile.css";

export const Profile: FunctionComponent<IProfileProps> = (props) => {
    return (
        <Fragment>
            <h3 className="uui-profile__title">{userUiI18n.getString(`profile.sub_titles.avatar`)}</h3>
            <Avatar className="uui-profile__avatar" src={props.userDetails.profilePic} />

            <h3 className="uui-profile__title">{userUiI18n.getString(`profile.sub_titles.organisation`)}</h3>
            <p className="uui-profile__content" data-hook="profile-institution">
                {props.userDetails.institution}
            </p>

            <h3 className="uui-profile__title">{userUiI18n.getString(`profile.sub_titles.given_name`)}</h3>
            <p className="uui-profile__content" data-hook="profile-first-name">
                {props.userDetails.firstName}
            </p>

            <h3 className="uui-profile__title">{userUiI18n.getString(`profile.sub_titles.family_name`)}</h3>
            <p className="uui-profile__content" data-hook="profile-surname">
                {props.userDetails.surname}
            </p>
        </Fragment>
    );
};
